// Everything the browser hands focus to on Tab. `tabindex="-1"` nodes match some of
// these but are filtered out below: they are programmatic focus targets (a panel
// box, a roving-tabindex calendar day), not Tab stops of their own.
const FOCUSABLE_SELECTOR = [
  'a[href]',
  'area[href]',
  'button',
  'input:not([type="hidden"])',
  'select',
  'textarea',
  'iframe',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
  '[tabindex]',
].join(',');

/**
 * The controls inside `container` that Tab would visit, in document order.
 *
 * A dropdown that swaps panels keeps the inactive ones mounted so they hold on to
 * their in-progress state, so this skips anything under a `hidden` ancestor:
 * display:none content is not a Tab stop, and `hidden` is what marks a panel as off
 * screen.
 */
export const getFocusableElements = (container: HTMLElement): HTMLElement[] =>
  Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    element =>
      element.tabIndex >= 0 &&
      !element.hasAttribute('disabled') &&
      element.getAttribute('aria-hidden') !== 'true' &&
      !element.closest('[hidden]'),
  );
